import { Floor } from './floor.interface';
import { Tag } from './tag.interface';
import { Tenant } from '@app/shared/models/tenant.interface';
import { Gateway } from '@app/api/building/gateway/Gateway';
import { ServiceLevelType } from '@app/shared/models/service-level-type';

export interface Building {
  id: number;
  name: string;
  address: Address;
  floors: Floor[];
  tags: Tag[];
  tenants: Tenant[];
  timeZone: string;
  thumbnailImage: string;
  realTimeBuildingData?: RealTimeBuildingData;
  latitude: number;
  longitude: number;
  managingCompanyId: number;
  statusFrequencySeconds: number;
  gateways?: Gateway[];
  serviceLevel?: string;
  buildingFloorAreaSqMeters?: number;
  serviceLevelStartDate?: string;
  enhancedSecurity?: boolean;
}

export function createDummyBuildingForTest(): Building {
  return {
    id: 1,
    name: 'Building 1',
    address: {
      addressLine1: '123 Main St',
      addressLine2: '',
      addressLine3: '',
      postcode: '12345',
      country: 'Australia',
      city: 'Melbourne'
    },
    timeZone: 'Australia/Melbourne',
    floors: [],
    tags: [],
    tenants: [],
    thumbnailImage: '',
    latitude: 0,
    longitude: 0,
    managingCompanyId: 1,
    statusFrequencySeconds: 0,
    serviceLevel: ServiceLevelType.SMART_START,
    buildingFloorAreaSqMeters: 100,
    enhancedSecurity: false
  };
}

export interface Address {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  postcode: string;
  country: string;
  city: string;
}

export interface RealTimeBuildingData {
  nodeCount: number;
  offlineNodeCount: number;
  userCount: number;
  occupancy: number;
  energyConsumption: number;
  state: BuildingWarningState;
}

export enum BuildingWarningState {
  OK,
  MODERATE,
  SEVERE
}

export class ManagingCompany {
  id: number;
  companyName: string;
}

export const mockBuilding: Building = {
  id: 100,
  address: {
    addressLine1: 'Line1',
    addressLine2: 'Line2',
    addressLine3: 'Line3',
    country: 'Australia',
    postcode: '3000',
    city: 'Melbourne'
  },
  name: 'Mock Building',
  floors: [],
  tags: [],
  timeZone: 'Australia/Melbourne',
  thumbnailImage: '',
  realTimeBuildingData: {
    energyConsumption: 0,
    nodeCount: 1,
    offlineNodeCount: 1,
    userCount: 1,
    occupancy: 1,
    state: 0
  },
  latitude: 121,
  longitude: 221,
  managingCompanyId: 1,
  statusFrequencySeconds: 300,
  serviceLevel: ServiceLevelType.SMART_START,
  buildingFloorAreaSqMeters: 100,
  tenants: []
};

export interface CoordinatesAndTimezone {
  latitude: number;
  longitude: number;
  timezone: string;
}
